import React from "react";
import "./attachmentContainer.css";
import AttachmentHoverPreviewPortal, {useAttachmentHoverPreview} from "./AttachmentHoverPreview";
import {isImageAttachment} from "./attachmentPreviewUtils";
export function getAttachmentFileName(item) {
    return item?.originalName || item?.uploadName || item?.name || "파일";
}

function getFileExtension(name, isImage) {
    if (isImage) return "IMG";
    const parts = String(name || "").split(".");
    if (parts.length < 2) return "FILE";
    return parts.pop().slice(0, 4).toUpperCase();
}

export default function AttachmentFileList({
    items,
    readOnly,
    onRemove,
    onOpen,
    variant = "file",
    hoverPreview = false,
}) {
    const list = Array.isArray(items) ? items.filter(Boolean) : [];
    const {
        preview,
        setPreview,
        closePreview,
        handleRowMouseEnter,
        handleRowMouseLeave,
    } = useAttachmentHoverPreview(hoverPreview);

    if (list.length === 0) {
        return null;
    }

    const isImage = variant === "image";

    return (
        <>
            <ul className="attch-file-list">
                {list.map((item, index) => {
                    const fileName = getAttachmentFileName(item);
                    const canHoverPreview = hoverPreview && isImageAttachment(item, fileName);
                    return (
                        <li
                            key={item.id ?? `attachment-${index}`}
                            className="attch-file-row"
                            onMouseEnter={canHoverPreview ? (event) => handleRowMouseEnter(event, item, fileName) : undefined}
                            onMouseLeave={canHoverPreview ? handleRowMouseLeave : undefined}
                        >
                            <span className="attch-file-row__ext">{getFileExtension(fileName, isImage)}</span>
                            <button
                                type="button"
                                className={`attch-file-row__name${onOpen ? " attch-file-row__name--link" : ""}`}
                                onClick={onOpen ? () => onOpen(item, index) : undefined}
                                tabIndex={onOpen ? 0 : -1}
                                title={fileName}
                            >
                                {fileName}
                            </button>
                            {!readOnly && onRemove && (
                                <button
                                    type="button"
                                    className="attch-file-row__remove"
                                    aria-label={`${fileName} 제거`}
                                    onClick={() => onRemove(item, index)}
                                >
                                    ×
                                </button>
                            )}
                        </li>
                    );
                })}
            </ul>
            {hoverPreview && (
                <AttachmentHoverPreviewPortal
                    preview={preview}
                    onClose={closePreview}
                    setPreview={setPreview}
                />
            )}
        </>
    );
}
